import { lazy as reactLazy } from 'react';

function lazy(fn, name) {
  const l = reactLazy(() => fn());
  l.displayName = name ? `LazyLoaded<${name}>` : 'LazyLoaded';
  return l;
}

export { default as Landing } from './Landing';
export { default as HomeGateway } from './HomeGateway';
export { default as BusinessProfileGateway } from './BusinessProfileGateway';
export { default as Education } from './Education';
export { OrphanAccountOptions } from './OrphanAccountOptions';
export const Login = lazy(() => import(/* webpackChunkName: 'login' */'./Login'), 'Login');
export const Logout = lazy(() => import(/* webpackChunkName: 'login' */'./Logout'), 'Logout');
export const Callback = lazy(() => import(/* webpackChunkName: 'login' */'./Callback'), 'Callback');
export const Download = lazy(() => import(/* webpackChunkName: 'pages.download' */'./Download'), 'Download');
export const Help = lazy(() => import(/* webpackChunkName: 'pages.help' */'./Help'), 'Help');
export const AccountNotFound = lazy(() => import(/* webpackChunkName: 'pages.AccountNotFound' */'./AccountNotFound'), 'AccountNotFound');
export const AccountNotFoundMobile = lazy(() => import(/* webpackChunkName: 'pages.AccountNotFoundMobile' */'./AccountNotFoundMobile'), 'AccountNotFoundMobile');
export const AccountSettings = lazy(() => import(/* webpackChunkName: 'pages.AccountSettings' */'./AccountSettings'), 'AccountSettings');
export const ProductLanding = lazy(() => import(/* webpackChunkName: 'pages.ProductLanding' */'./ProductLanding'), 'ProductLanding');
export const Products = lazy(() => import(/* webpackChunkName: 'pages.Products' */'./Products'), 'Products');
export const EducationGettingStarted = lazy(() => import(/* webpackChunkName: 'pages.education' */'./Education/GettingStarted'), 'GettingStarted');
export const EducationRunningAndGrowing = lazy(() => import(/* webpackChunkName: 'pages.education' */'./Education/RunningAndGrowing'), 'RunningAndGrowing');
export const BusinessOverview = lazy(() => import(/* webpackChunkName: 'pages.BusinessOverview' */'./BusinessOverview'), 'BusinessOverview');
